var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9014 6.79796L13.8213 5.82465C14.7075 5.52924 15.1507 5.38153 15.3846 5.61544C15.6185 5.84935 15.4708 6.29247 15.1753 7.17871L14.202 10.0986C13.6986 11.6088 13.4469 12.3639 12.9054 12.9054C12.3639 13.4469 11.6088 13.6986 10.0986 14.202L7.17871 15.1753C6.29247 15.4708 5.84935 15.6185 5.61544 15.3846C5.38153 15.1507 5.52924 14.7075 5.82465 13.8213L6.79796 10.9014C7.30136 9.39118 7.55306 8.63608 8.09457 8.09457C8.63608 7.55306 9.39118 7.30136 10.9014 6.79796Z",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M10.5 10.5L10.4936 10.5064",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1 10.5C1 6.02166 1 3.78249 2.39124 2.39124C3.78249 1 6.02166 1 10.5 1C14.9783 1 17.2175 1 18.6088 2.39124C20 3.78249 20 6.02166 20 10.5C20 14.9783 20 17.2175 18.6088 18.6088C17.2175 20 14.9783 20 10.5 20C6.02166 20 3.78249 20 2.39124 18.6088C1 17.2175 1 14.9783 1 10.5Z",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon3);
export default __webpack_public_path__ + "static/media/LineIcon3.042b78bfd279088221696567da7a139f.svg";
export { ForwardRef as ReactComponent };